import strFunc from "@/lib/lyg/string";
import getXcolumnJson from "./xcolumn/list";
import ListSimpleArea from "@/pcomponents/common/crud/list/list_simple";
import { useState } from 'react';

function WordListArea(props: any) {
  let myProps = {
    word_info_arr: [],
    set_word_info_arr: (inData: any) => { },
    url_prefix: "",
    delete_word_by_ajax: (inData: any) => { },
    ...props
  };
  const xColumnArr = getXcolumnJson();
  const [select_row_num_arr, set_select_row_num_arr] = useState<any>([]);

  const chnage_order_by_row_drag = (drag_row_num: number, drop_row_num: number) => {
    let new_word_info_arr = [...myProps.word_info_arr];
    let drag_item = new_word_info_arr[drag_row_num];
    new_word_info_arr.splice(drag_row_num, 1);
    new_word_info_arr.splice(drop_row_num, 0, drag_item);
    for (let i = 0; i < new_word_info_arr.length; i++) {
      new_word_info_arr[i].cont_no = i + 1;
    }
    myProps.set_word_info_arr(new_word_info_arr);
  };

  const get_td_render_tag = (inData: any) => {
    let key = inData.key;
    let render_str = inData.render_str;
    let row_num = inData.row_num;
    if (key == "row_view_manage") {
      render_str = (
        <div className="my_flex_center">
          <button className="btn btn-dark"
            onClick={() => {
              let full_mp3_url = "";
              if (!strFunc.is_empty(inData.info.mp3_file_url)) {
                full_mp3_url = inData.info.mp3_file_url;
              } else {
                full_mp3_url = myProps.url_prefix + "/audio/" + inData.info.mp3_file;
              }
              window.open(full_mp3_url, "_blank");
            }}
          >mp3</button>
          {inData.info.uid == "" &&
            <button className="btn btn-red"
              onClick={() => {
                let new_word_info_arr = [];
                for (let i = 0; i < myProps.word_info_arr.length; i++) {
                  if (i != row_num) {
                    new_word_info_arr.push(myProps.word_info_arr[i]);
                  }
                }
                myProps.set_word_info_arr(new_word_info_arr);
              }}
            >x</button>
          }
          {
            inData.info.uid != "" &&
            <button className="btn btn-red"
              onClick={() => {
                myProps.delete_word_by_ajax({ del_word_arr: [inData.info] });
              }}
            >x</button>
          }
        </div>
      );
    } else if (key == "row_view_order") {
      render_str = (
        <div className="my_flex_center">
          <div
            style={{
              width: 40,
              textAlign: "center",
              cursor: "grab",
              userSelect: "none",
              borderRadius: "4px",
              backgroundColor: "#f0f0f0",
              transition: "all 0.2s",
              fontSize: "18px",
              fontWeight: "bold",
              color: "#666"
            }}
            draggable={true}
            onDragStart={(e) => {
              e.dataTransfer.effectAllowed = "move";
              e.dataTransfer.setData("text/plain", row_num.toString());
              e.currentTarget.style.cursor = "grabbing";
              e.currentTarget.style.opacity = "0.5";
            }}
            onDragEnd={(e) => {
              e.currentTarget.style.cursor = "grab";
              e.currentTarget.style.opacity = "1";
            }}
            onDragOver={(e) => {
              e.preventDefault();
              e.dataTransfer.dropEffect = "move";
              e.currentTarget.style.backgroundColor = "#e0e0e0";
            }}
            onDragLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#f0f0f0";
            }}
            onDrop={(e) => {
              e.preventDefault();
              e.currentTarget.style.backgroundColor = "#f0f0f0";
              const drag_row_num = parseInt(e.dataTransfer.getData("text/plain"));
              const drop_row_num = row_num;
              if (drag_row_num !== drop_row_num) {
                chnage_order_by_row_drag(drag_row_num, drop_row_num);
              }
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#e8e8e8";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#f0f0f0";
            }}
          >
            {row_num + 1}
          </div>
        </div>
      );
    }

    return render_str;
  }

  const on_change_row_input = (inData: any) => {
    let opt_obj = {
      row_num: 0,
      key: "",
      value: "",
      change_infoArr: [],
      ...inData
    };
    let change_infoArr = opt_obj.change_infoArr;
    let row_num = opt_obj.row_num;
    let key = opt_obj.key;
    let value = opt_obj.value;

    if (key == "e_script") {
      if(change_infoArr[row_num].cont_part=="word"){
        change_infoArr[row_num].mp3_file = value.toLowerCase() + ".mp3";
      }
    }

    return change_infoArr;
  };

  return (
    <div>
      <ListSimpleArea
        xColumnArr={xColumnArr}
        infoArr={myProps.word_info_arr}
        setInfoArr={myProps.set_word_info_arr}
        select_row_num_arr={select_row_num_arr}
        set_select_row_num_arr={set_select_row_num_arr}
        is_grid={true}
        is_checkbox={false}
        is_select_click_multy={false}
        get_td_render_tag={get_td_render_tag}
        on_change_row_input={on_change_row_input}
        table_style={{
          width: "auto",
        }}
      ></ListSimpleArea>
      <div>
        ※ mp3_file_url 은 연결된 mp3 파일이 없을 경우 전체mp3주소를 직접넣는칸.(평소에는 빈칸으로두기)
      </div>
    </div>
  );
};
export default WordListArea;